import { render, staticRenderFns } from "./PurchaseLoading.vue?vue&type=template&id=00042665"
import script from "./PurchaseLoading.vue?vue&type=script&lang=js"
export * from "./PurchaseLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports